import { projectNames } from '@/shared/constants/system';

export function buildRefLink(cardHash: string, projectName: string) {
  const linksMap = {
    [projectNames.MOSAP]: `https://invite.mosap.ru/?referral=${cardHash}`,
    [projectNames.MTI]: `https://invite.moicapital.ru/?referral=${cardHash}`,
    [projectNames.SF]: `https://invite.synergy.ru/?referral=${cardHash}`,
    [projectNames.PEOPLE]: `https://invite.synergy.ru/?referral=${cardHash}`,
  };

  return linksMap[projectName] ?? '';
}
